import React, { useEffect, useState } from 'react';
import BomListUl from './BomListUl';
import { Drop } from "../../../component/Global/DragAndDrop/Drop";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useBOMStore } from 'src/hooks/bom';
import System from 'src/helper/system';

const BomList = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { bom_listing } = props;
    const [listOfBOM, setListOfBOM] = useState({});
    const [{ total_bom }, { }, { }] = useBOMStore();
    const { translation: t } = System;

    useEffect(() => {
        setListOfBOM(bom_listing);
    }, [bom_listing]);

    return (
        <Drop>
            {!(listOfBOM && Object.keys(listOfBOM).length > 0) && __check(['BOM_PROJECT_API_CALL']).render}
            <div style={{ display: total_bom > 0 ? 'block' : 'none' }} className="accordion m-t-20 mb-2 position-relative" id="boms">
                <div>
                    {__check(['BOM_PROJECT_API_CALL'], { overlay: true }).render}
                </div>
                <div className="accordion-item ">
                    <h2 className="accordion-header mb-1" id="headingOne">
                        <button className="accordion-button" type="button" data-toggle="collapse"
                            data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <b className="font-24">{t('yourBoms')}</b>
                        </button>
                    </h2>
                    <h3 className="ps-3 font-arial font-bold font-13 mt-0 mb-3">{t('totalResults')} {total_bom}</h3>
                    <div id="collapseOne" className="accordion-collapse collapse in" aria-labelledby="headingOne"
                        data-parent="#accordionExample">
                        <div className="accordion-body p-0">
                            {listOfBOM && Object.keys(listOfBOM).length > 0 &&
                                <BomListUl listOfBOM={listOfBOM} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Drop>
    );
}

export default BomList;